module.exports = {
	"config": {
		"BASE_URL": "https://bc-api.fat.imcplus.net",
		"LANGUAGE_SERVICE_URL": "https://bc-api.fat.imcplus.at/vicky-internationalisation/rest/languagebundles/vicky-spa",
		"NAVIGATION_URL_RELATIVE": "config/navigation/navigation.json",
		"PERMISSION_URL_RELATIVE": "config/permission/permission.json",
		"ASSIGNABLE_PERMISSIONS_URL_RELATIVE": "config/permission/assignment.json",
		"ASSIGNABLE_DISPOSER_PERMISSIONS_URL_RELATIVE": "config/permission/disposer.json",
		"FAULT_LOGO_URL_RELATIVE": "images/default-logo.png",
		"LOGO_BASEURL": "https://www.sparkasse.at/tiny/simple-content-services/institute-logo_",
		"PREPAID_LOGO_URL": "https://www.sparkasse.at/tiny",
		"PRESTO_DATE_FORMAT": "YYYY-MM-DDTHH:mm:ssZZ",
		"USERSNAP_KEY": "62b7d22d-13b0-4901-9eca-5dabab761d6b",
		"USERSNAP_CLASSIC_NEW_KEY": "ba348b7d-09f2-4727-b053-09b46cab8cba",
		"CHATVISOR_SCRIPT_URL": "https://store.fat.sparkasse.at/chatvisor/cdn/js/mE1T7k8n2k.js",
		"PSD2_DEADLINE": "20190914",
		"PSD2_PIN_ENABLED": "true",
		"ORDER_CSV_EXPORT_ENABLED": "true",
		"SERVICE_SHOP_URL": "https://telebankingpro.fat.imcplus.net/dashboard/service-shop/service-details/klick-kredit",
		"SECURITY": {
			"LOGOUT_URL": "https://login.fat.sparkasse.at/sts/oauth/authorize?response_type=token&client_id=vicky&redirect_uri=http://localhost:8008/auth",
			"REVOKE_URL": "http://localhost:8008/sts/oauth/logout",
			"LOGOUT_REDIRECT_URL": "/sts/oauth/authorize?client_id=vicky&response_type=token",
			"TIZIANO_PK_MODULUS": "C5B20032AD5580E25AF216009DF3AF1E022E32175C028BCA450DB07A55D1B2BA5AA369D43079F3BFD016CDCEDA09EE5321BBC273052803B49B56A324D755808F3F15B008445A21A3DBA0BFA78BBF578B0518A904D2DCB4A2588264B58DE79E4B9885F938215A82074B24CE3A047496F3C92A578B952C62526BEE4BF66D2AD2DC2BC2D3AA9C68B704A5C6DB25C318E86E35AB6E7CDBDA212EFC46F8744B5E2CA9630C03B202897CC7FA4911F9079C272151FDBE3881D5C7807646AB498D2B13E25F07DE88F0B759A80CB441BDE89CF1E2C78CC94A0AAEECBBAE2545494BA48FEF1CAA4AFFC446C5AE1D483EBBC8D6B01761FCB717A01E1A56DD04222FF9EEABEF",
			"TIZIANO_PK_EXPONENT": "010001"
		},
		"ENDPOINTS": {
			"ebv_security_service": "https://bc-api.fat.imcplus.net/ebv-secapp/rest",
			"elastic_search": "https://bc-api.fat.imcplus.net/viapi/api",
			"ebv_account_service": "https://bc-api.fat.imcplus.net/ebv-account/rest",
			"vicky_account_service": "https://bc-api.fat.imcplus.net/vicky-account/rest",
			"card_service": "https://bc-api.fat.imcplus.net/vicky-card/rest",
			"user_profile_service": "https://bc-api.fat.imcplus.net/vicky-ups/rest",
			"user_service": "https://bc-api.fat.imcplus.net/ebv-user/rest",
			"fx_trade_service": "https://bc-api.fat.imcplus.net/vicky-fx-trade/rest",
			"tan_card_service": "https://bc-api.fat.imcplus.net/ebv-tancard/rest",
			"account_statement_service": "https://bc-api.fat.imcplus.net/vicky-account-statement/rest",
			"static_data_service": "https://rest-a.alfa.spardat.at",
			"payment_service": "https://bc-api.fat.imcplus.net/vicky-payment/rest",
			"contact_service": "https://bc-api.fat.imcplus.net/vicky-contact/rest",
			"business_partner_service": "https://bc-api.fat.imcplus.net/vicky-bussi/rest",
			"mbs_mad_service": "https://bc-api.fat.imcplus.net/vicky-mbsmad/rest",
			"mbs_communicator_service": "https://bc-api.fat.imcplus.net/vicky-mbscom/rest",
			"prepaid_service": "https://prepaid.stable.cards.microf.cs.eb.lan.at/cards-prepaid/rest",
			"rum_service": "https://bc-api.fat.imcplus.net/vicky-rum",
			"authorization_service": "https://bc-api.fat.imcplus.net/ebv-authorization/rest",
			"notification_service": "https://bc-api.fat.imcplus.net/vicky-message/rest",
			"licence_holder_service": "https://bc-api.fat.imcplus.net/ebv-licenceholder/rest",
			"presto_service": "https://api.fat.imcplus.net/fat1/rest",
			"dashboard_service": "https://bc-api.fat.imcplus.net/vicky-tilestore/rest",
			"standingorder_service": "https://bc-api.fat.imcplus.net/standingorder/rest",
			"vigrator_service": "https://bc-api.fat.imcplus.net/vicky-vigrator/rest",
			"autocom_service": "https://bc-api.fat.imcplus.net/vicky-autocom/rest",
			"tag_service": "https://bc-api.fat.imcplus.net/vicky-tags/rest",
			"alice_service": "http://localhost:8008/default/emil",
			"ebv_encryption_credentials_service": "https://bc-api.fat.imcplus.net/ebv-encryption-credentials/rest",
			"document_service": "https://bc-api.fat.imcplus.net/vicky-dose/rest",
			"trade_finance_service": "https://bc-api.fat.imcplus.net/vicky-doka/rest",
			"ebv_messages_service": "https://bc-api.fat.imcplus.net/ebv-message/rest",
			"auth_service": "https://login.fat.erste-group.net"
		},
		"FEATURES": {
			"sprepaid_tile": "true",
			"list_filters_transactions": "true",
			"rum_enabled": "true",
			"disposer_login": "true"
		},
		"HEADER": {
			"BANKING_URL": "http://localhost:8008/home",
			"DASHBOARD_URL": "http://localhost:4200",
			"MESSENGER_URL": "http://localhost:4200",
			"SPECIAL_URL": "https://www.sparkasse.at/coronavirus-unternehmen"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./app/config/config.json
// module id = 1629
// module chunks = 1